import type { IconName } from "../icon";
import type { ExportTableFormat, ExportTableFormatDetail } from "./types-export-table-dialog";

/** Formatos de saída do modal, na ordem do Figma 4988:57404 (RN002 de "Exportar Tabela"). */
export const EXPORT_TABLE_FORMATS: readonly ExportTableFormatDetail[] = [
  { value: "pdf", label: "PDF", description: "Formato .pdf" },
  { value: "xlsx", label: "Planilha Excel", description: "Formato .xlsx" },
  { value: "csv", label: "Texto Separado", description: "Formato .csv" },
];

/** Ícones do Figma (modal-exportar-tabela, 4988:57404) de cada formato. */
export const EXPORT_TABLE_FORMAT_ICONS: Record<ExportTableFormat, IconName> = {
  pdf: "file-pdf",
  xlsx: "table",
  csv: "file",
};
